import { JobsComponent } from './jobs/jobs.component';
import {  NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ClipboardModule } from 'ngx-clipboard';
import { BBSFControlsModule } from 'bbsf-controls';
import { BlockUIModule } from 'ng-block-ui';
import { AuthModule } from '../core/auth.module';
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { EmptyDataModule } from '../empty-data/empty-data.module';
import { JobsService } from '../shared/Services/JobsService.service';
import { AuthService, BBSFTranslateService, EnvironmentService, UtilityService } from 'bbsf-utilities';


@NgModule({
  declarations: [JobsComponent],
  imports: [
    
    RouterModule.forRoot([
      { path: '',component:JobsComponent},
      { path: '', redirectTo: '', pathMatch: 'full'},
    ]),
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    AuthModule,
    RouterModule,
    CommonModule,
    ClipboardModule,
    BlockUIModule.forRoot(),
    ReactiveFormsModule,
    FormsModule,
    BBSFControlsModule,
    NgbModule,
    EmptyDataModule
  ],
  providers:[
    EnvironmentService,
    UtilityService,
    AuthService,
    BBSFTranslateService,
    JobsService
  ]
})
export class JobsModule { }
